// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"bfd2f2a5","492":"459639fc","880":"0ae2e253","892":"7a33fce6"}[chunkId] + ".chunk.css";
};